import src from "IMAGE";
export default { src, width: 215, height: 45, blurWidth: 0, blurHeight: 0};
